var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 2.90244H9.6C9.6 1.98645 8.88368 1.2439 8 1.2439C7.11632 1.2439 6.4 1.98645 6.4 2.90244ZM5.2 2.90244C5.2 1.29946 6.4536 0 8 0C9.5464 0 10.8 1.29946 10.8 2.90244H15.4C15.7314 2.90244 16 3.1809 16 3.52439C16 3.86788 15.7314 4.14634 15.4 4.14634H14.3447L13.4071 14.1898C13.2583 15.7838 11.966 17 10.421 17H5.57895C4.03403 17 2.74172 15.7838 2.5929 14.1898L1.65526 4.14634H0.6C0.268632 4.14634 0 3.86788 0 3.52439C0 3.1809 0.268632 2.90244 0.6 2.90244H5.2ZM6.8 6.84146C6.8 6.49797 6.53136 6.21951 6.2 6.21951C5.86863 6.21951 5.6 6.49797 5.6 6.84146V13.061C5.6 13.4045 5.86863 13.6829 6.2 13.6829C6.53136 13.6829 6.8 13.4045 6.8 13.061V6.84146ZM9.8 6.21951C10.1314 6.21951 10.4 6.49797 10.4 6.84146V13.061C10.4 13.4045 10.1314 13.6829 9.8 13.6829C9.46864 13.6829 9.2 13.4045 9.2 13.061V6.84146C9.2 6.49797 9.46864 6.21951 9.8 6.21951ZM3.78733 14.0699C3.87662 15.0263 4.652 15.7561 5.57895 15.7561H10.421C11.348 15.7561 12.1234 15.0263 12.2126 14.0699L13.1391 4.14634H2.86086L3.78733 14.0699Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3c122b96c2ff2246ffbe0b570e4e2bcf.svg";
export { ForwardRef as ReactComponent };